export default {
  scantools: state => state.scantools,
  reportTemplates: state => state.reportTemplates,
  areas: state => state.areas,
  apps: state => state.apps,
  techInfo: state => state.techInfo
}



// WEBPACK FOOTER //
// ./src/store/modules/report/getters.js